import moment from 'moment';
export function humanizeDuration(startTime, endTime) {
  var durationObj = moment.duration(moment(endTime).diff(moment(startTime)));
  var d = durationObj.days();
  var h = durationObj.hours();
  var m = durationObj.minutes();
  var s = durationObj.seconds();
  var ms = durationObj.milliseconds();
  return "".concat(d ? d + 'd' : '', " ").concat(h ? h + 'h' : '', " ").concat(m ? m + 'm' : '', " ").concat(s ? s + 's' : '', " ").concat(ms ? ms + 'ms' : '', " ").concat(!h && !m && !s && !ms ? '---' : '');
}